import React from 'react';
import { Select } from '@clockout-dev/design-elements';
import { SwapOutlined } from '@ant-design/icons';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import { FEE_STRATEGY_OPTIONS } from '../../../configuration.constants';
import styles from '../styles/feeStructureForm.module.scss';

function FeeStrategyCard({ value, enabled, onChange, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Fee Strategy"
            icon={<SwapOutlined />}
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <Select
                id="feeStrategy"
                size="large"
                value={value}
                options={FEE_STRATEGY_OPTIONS}
                onChange={onChange}
                className={styles.select}
            />
        </ConfigurationCard>
    );
}

export default FeeStrategyCard;
